import { useState } from "react"
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { toast } from "react-toastify"
import { authCRUD } from "../../../actions/auth"

const schema = Yup.object().shape({
  name: Yup.string().required('Group name is required'),
})

export const AddUserGroup = ({ setIndex, index }) => {

  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    initialValues: { name: '' },
    validationSchema: schema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      setLoading(true)
      authCRUD.addGroup(values)
        .then(() => {
          toast.success('User group created.', { autoClose: 7000 })
          resetForm()
          if (setIndex) setIndex(index + 1)
        })
        .catch((error) => {
          toast.error(error?.response?.data?.name?.[0] || error?.message || 'Failed to create group', { autoClose: 7000 })
        })
        .finally(() => {
          setLoading(false)
          setSubmitting(false)
        })
    }
  })

  return (
    <div className="modal fade bs-example-modal-lg" tabIndex="-1" role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">New User Group</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <div className="mb-3">
                    <label htmlFor="group_name" className="form-label">User Group Name <span className="text-danger">*</span></label>
                    <input type="text" id="group_name" className="form-control" placeholder="User Group Name" {...formik.getFieldProps('name')} />
                    {formik.touched.name && formik.errors.name && (
                      <span className='text-danger' style={{ fontSize: '13px' }}>{formik.errors.name}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <a href="javascript:void(0);" className="btn btn-outline-danger fw-medium" data-bs-dismiss="modal"><i className="ri-close-line me-1 align-middle"></i> Close</a>
              <button type="submit" className="btn btn-success" disabled={formik.isSubmitting}>
                {!loading && <span><i className="las la-save la-lg"></i> &nbsp; Save changes</span>}
                {loading && <span>Please wait... <span className='spinner-border spinner-border-sm ms-2'></span></span>}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
